import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { Box, Button, DataTable } from '../../../../common/components';
import {
  applyFilter,
  clearData,
} from '../../../../common/components/DataTable/redux/dataTableActions';
import { InternalButtonBar } from '../../../layout/components/InternalButtonBar/InternalButtonBar';
import formatDateTime from '../../../../helpers/formatDateTime';
import startCase from '../../../../helpers/socratesLodash/startCase';
import Select from 'react-select';
import selectTheme from '../../../../helpers/selectTheme';

/*****************************
 BrokersApplication DataTable
 *****************************/

const STATUS_OPTIONS = [
  { label: 'Applied', value: 'applied' },
  { label: 'Approved', value: 'approved' },
];
export default class BrokerApplicationList extends Component {
  constructor(props) {
    super(props);
    this.handleSearchUpdate = this.handleSearchUpdate.bind(this);
  }

  componentDidMount() {
    const {
      location: {
        query: { status },
      },
      dispatch,
    } = this.props;
    dispatch(applyFilter('brokerApplication', 'filter[status]', status ? status : ''));
  }

  componentWillUnmount() {
    clearData('brokerApplication');
  }

  handleRowClick(row) {
    this.props.dispatch(push('/admin/broker-applications/' + row.id));
  }

  handleSearchUpdate(event) {
    this.props.dispatch(
      applyFilter('brokerApplication', 'filter[name]', event.target.value),
    );
  }

  handleReferenceSearchUpdate = (event) => {
    const { dispatch } = this.props;
    dispatch(applyFilter('brokerApplication', 'filter[reference]', event.target.value));
  };

  handleStatusUpdate(option) {
    const { dispatch } = this.props;
    dispatch(
      applyFilter('brokerApplication', 'filter[status]', option ? option.value : ''),
    );
  }

  render() {
    const {
      location: {
        query: { status },
      },
    } = this.props;
    const formatBusinessType = (metadata) => {
      return `${startCase(metadata.business_type)}`;
    };
    return (
      <div>
        <Box>
          <Row>
            <Col sm={4}>
              <ControlLabel>Search Name</ControlLabel>
              <FormControl onChange={this.handleSearchUpdate} />
            </Col>
            <Col sm={4}>
              <ControlLabel>Search Reference</ControlLabel>
              <FormControl onChange={this.handleReferenceSearchUpdate} />
            </Col>

            <Col sm={4}>
              <ControlLabel>Status</ControlLabel>

              <Select
                theme={(theme) => selectTheme(theme)}
                options={STATUS_OPTIONS}
                isClearable
                onChange={(option) => this.handleStatusUpdate(option)}
                value={STATUS_OPTIONS.find((option) => option.value === status)}
              />
            </Col>
          </Row>
        </Box>

        <Box>
          <DataTable
            source="/brokers/applications/"
            name="brokerApplication"
            showTotal
            onRowSelect={this.handleRowClick.bind(this)}
          >
            <TableHeaderColumn dataField="id" isKey hidden />

            <TableHeaderColumn dataField="reference" width={'10%'}>
              Reference
            </TableHeaderColumn>

            <TableHeaderColumn dataField="name" dataSort width={'60%'}>
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="metadata"
              dataSort
              width={'10%'}
              dataFormat={formatBusinessType}
            >
              Type
            </TableHeaderColumn>

            <TableHeaderColumn dataField="status" dataSort={false} width={'10%'}>
              Status
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="activated_at"
              dataSort
              dataFormat={formatDateTime}
              width={'10%'}
            >
              Activation Date
            </TableHeaderColumn>
          </DataTable>

          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['broker.create'],
                    button: (
                      <Button
                        link={true}
                        to="/admin/broker-applications/new"
                        className="pull-right"
                        bsStyle="primary"
                        label="new Application"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}
